module.exports = __webpack_public_path__ + "img/temp_eid.3abf1072.png";